import React from "react";
import city from '../assets/city.jpg';
import "./InfoUs.css";

const InfoUs = () => {
    return (
        <div className="info-us-container">
            <div className="info-us-card">
                <div className="info-us-image">
                    <img src={city} alt="Ciudad" />
                </div>
                <div className="info-us-content">
                    <h1 className="info-us-title">SOBRE NOSOTROS</h1>
                    <p className="info-us-paragraph">
                        Somos una empresa dedicada a la innovación agrícola, comprometida con el desarrollo sostenible y la mejora de la productividad en el sector agrícola. Nuestra misión es proporcionar soluciones innovadoras que ayuden a los agricultores a enfrentar los desafíos del cambio climático y a mejorar la calidad de sus cultivos.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default InfoUs;